export default __webpack_public_path__ + "static/media/directory.23e366fa.svg";